import { useQueryClient, useMutation, useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useAvailabilities = ({ start, end, branches, employeeIds }) => {
  const { accountId } = useAccount();
  const queryClient = useQueryClient();

  const storeKey = ['availabilities', accountId, start, end, branches, employeeIds];
  const { isLoading, data, refetch } = useQuery(
    storeKey,
    () => api.fetchAvailabilities({ accountId, start, end, branches, employeeIds }),
    { staleTime: 0 }
  );

  const { mutateAsync: updateAvailability } = useMutation(
    ({ date, labelId, status, employeeId }) =>
      api.updateAvailabilities({
        accountId,
        body: { data: [{ employeeId, availabilities: [{ date, labels: [{ id: labelId, status }] }] }] }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(storeKey);
      }
    }
  );

  return {
    isLoading,
    updateAvailability,
    refetch,
    availabilities: data?.data || []
  };
};

export default useAvailabilities;
